import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["productCheckbox", "addonCheckbox", "plotOptionsFrame"]
  static values = { refreshUrl: String }

  connect() {
    this.updateAllAddons()
  }

  productChanged(event) {
    const productCheckbox = event.target
    const productValue = productCheckbox.value

    this.updateAddonsForProduct(productValue, productCheckbox.checked)
    this.refreshPlotOptions()
  }

  refreshPlotOptions() {
    const frame = this.plotOptionsFrameTarget
    if (!frame) return

    const url = new URL(this.refreshUrlValue, document.location)
    const params = url.searchParams

    params.set("showcase[showcase_type]", "demo")

    this.productCheckboxTargets.forEach(cb => {
      if (cb.checked) params.append("showcase[requested_product_types][]", cb.value)
    })

    this.addonCheckboxTargets.forEach(cb => {
      if (cb.checked && !cb.disabled) params.append("showcase[product_addons][]", cb.value)
    })

    const select = frame.querySelector("select")
    if (select) {
      Array.from(select.selectedOptions).forEach(opt => {
        params.append("showcase[plots][]", opt.value)
      })
    }

    frame.src = url.toString()
  }

  updateAddonsForProduct(productValue, isChecked) {
    const addonsForProduct = this.addonCheckboxTargets.filter(
      checkbox => checkbox.dataset.product === productValue
    )

    addonsForProduct.forEach(addonCheckbox => {
      if (isChecked) {
        addonCheckbox.disabled = false
      } else {
        addonCheckbox.disabled = true
        addonCheckbox.checked = false
      }
    })
  }

  updateAllAddons() {
    this.productCheckboxTargets.forEach(productCheckbox => {
      this.updateAddonsForProduct(productCheckbox.value, productCheckbox.checked)
    })
  }
}
